import moment from 'moment';

import { FeatureNote, Village } from '@/services/types';
import translateFromArray from '@/utils/get-translated-object';
import { GBP_MULTIPLIER, USD_MULTIPLIER } from '@/utils/currency';

export function applyCurrencyValue(
  value: number,
  currency: 'EUR' | 'USD' | 'GBP' = 'EUR',
) {
  if (currency === 'USD') {
    return Math.round(value * USD_MULTIPLIER);
  }
  if (currency === 'GBP') {
    return Math.round(value * GBP_MULTIPLIER);
  }
  return value;
}

export function getCurrencySymbol(currency: 'EUR' | 'USD' | 'GBP' = 'EUR') {
  if (currency === 'USD') return '$';
  if (currency === 'GBP') return '£';
  return '€';
}

export function getPriceIncludesData(village: Village, lang: string) {
  const priceIncludedFeatures = village.features.filter(
    ({ feature }) => feature.type === 'price_included',
  );

  let noteCounter = 1;
  const priceIncludesFeatures: FeatureNote[] = [];
  const priceIncludesNotes: FeatureNote[] = [];

  priceIncludedFeatures.forEach(({ feature, translations }) => {
    const translation = translateFromArray({
      lang,
      translations: feature.featureTranslation,
    });

    const hasNotes = translations.length > 0;
    const noteTranslation = translateFromArray({ lang, translations });

    if (hasNotes && noteTranslation?.note) {
      const featureWithNote = {
        description: translation?.title || '',
        noteNumber: noteCounter,
      };

      priceIncludesFeatures.push(featureWithNote);
      priceIncludesNotes.push({
        description: noteTranslation?.note,
        noteNumber: featureWithNote.noteNumber,
      });
      noteCounter++;
    } else {
      priceIncludesFeatures.push({
        description: translation?.title || '',
        noteNumber: undefined,
      });
    }
  });

  return { priceIncludesFeatures, priceIncludesNotes };
}

export function getFilteredDeals(village: Village) {
  return village.deals.filter(({ deal, enabled }) => {
    const now = moment();
    const enabledCondition = deal.enabled && enabled;
    const visibleCondition =
      now.isAfter(deal.visibleFrom) && now.isBefore(deal.visibleTo);

    return enabledCondition && visibleCondition;
  });
}

export function getContactLink(lang: string) {
  const langs = ['de', 'it', 'fr'];
  if (langs.includes(lang)) {
    return `/${lang}/contacts`;
  }
  return '/contacts';
}
